
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { Classname } from "@rivtn/noseur";
import Btn from "../common/Btn";
import MatchRow from "../common/MatchRow";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import SectionHeader from "../common/SectionHeader";
import styles from "../../assets/style.module.css";
import { IProfileWebsite, ITournamentEditionMatch } from "../../../../../services";

export interface UpcomingMatchesProps {
    basePath: string;
    publicId: string;
    website: IProfileWebsite;
    matches: ITournamentEditionMatch[];
}

function UpcomingMatches({ website, basePath, publicId, matches }: UpcomingMatchesProps) {

    const labels = i18nManager.Labels.home;
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);

    if (!matches.length) return null;

    return (<section className={Classname.build(styles["section"], styles["section-alt"])}>
        <div className={styles["container"]}>
            <SectionHeader eyebrow={labels.matches_eyebrow} title={labels.matches_title} titleEm={labels.matches_title_em}
                action={<Btn variant="ghost" size="sm" to={{ pathname: pagePath(basePath, "SCHEDULE"), search: searchParams.toString() }}>{labels.full_schedule} <i className="fa fa-arrow-right" /></Btn>} />
            <div className={styles["matches"]}>
                {matches.map((m) => (<MatchRow key={m.external_id} publicId={publicId} website={website} match={m} />))}
            </div>
        </div>
    </section>);
}

export default UpcomingMatches;
